var data = {
  authToken: '',
  userName: '',
  orgnzPstn: '',
  cntrCd: '',
  brncCd: '',
  akdrnk: 0,
  akdmi3: '',
  userId: '',
  empId: '',
  loginGbn: '',
  gnrlName: '',
  cntrName: ''
}

var mutations = {
  'SET_USER'(state, user) {
    state.authToken = user.authToken;
    state.userName = user.userName;
    state.orgnzPstn = user.orgnzPstn;
    state.cntrCd = user.cntrCd;
    state.brncCd = user.brncCd;
    state.akdrnk = user.akdrnk;
    state.akdmi3 = user.akdmi3;
    state.userId = user.userId;
    state.empId = user.empId;
    state.loginGbn = user.loginGbn;
    state.gnrlName = user.gnrlName;
    state.cntrName = user.cntrName;
  },
  'MOD_USER'(state, user) {
    state.userName = user.userName;
    state.orgnzPstn = user.orgnzPstn;
    state.cntrCd = user.cntrCd;
    state.brncCd = user.brncCd;
    state.akdrnk = user.akdrnk;
    state.akdmi3 = user.akdmi3;
    state.userId = user.userId;
    state.empId = user.empId;
    state.loginGbn = user.loginGbn;
    state.gnrlName = user.gnrlName;
    state.cntrName = user.cntrName;
  }
};

var actions = {
  clearUser: ({commit}) => {
    var user = {
      authToken: '',
      userName: '',
      orgnzPstn: '',
      cntrCd: '',
      brncCd: '',
      akdrnk: 0,
      akdmi3: '',
      userId: '',
      empId: '',
      loginGbn: '',
      gnrlName : '',
      cntrName : ''
    };
    commit('SET_USER', user);
  },
};

var getters = {
  isLogin(state) {
    console.log('session.js <isLogin>', state.authToken);
    if(state.authToken == '') {
      return false;
    }
    if(typeof state.authToken == 'undefined') {
      return false;
    }
    return true;
  },
  authToken: state => state.authToken,
  userName: state => state.userName,
  orgnzPstn: state => state.orgnzPstn,
  cntrCd: state => state.cntrCd,
  brncCd: state => state.brncCd,
  akdrnk: state => state.akdrnk,
  akdmi3: state => state.akdmi3,
  userId: state => state.userId,
  empId: state => state.empId,
  loginGbn : state => state.loginGbn,
  gnrlName : state => state.gnrlName.trim(),
  cntrName : state => state.cntrName.trim()
};

export default {
  state:data,
  getters,
  actions,
  mutations
}
